import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { supabase } from '@/integrations/supabase/client';
import { useI18n } from '@/contexts/I18nContext';

// Mapeamento de interesses para traduções
const interestsTranslations: Record<string, Record<string, string>> = {
  en: {
    'Reading': 'Reading',
    'Hiking / Trekking': 'Hiking / Trekking',
    'Photography': 'Photography',
    'Gaming (Video Games / Board Games)': 'Gaming (Video Games / Board Games)',
    'Cooking / Baking': 'Cooking / Baking',
    'Traveling': 'Traveling',
    'Cycling (Road / Mountain)': 'Cycling (Road / Mountain)',
    'Running': 'Running',
    'Weightlifting / Fitness': 'Weightlifting / Fitness',
    'Yoga / Pilates': 'Yoga / Pilates',
    'Swimming': 'Swimming',
    'Surfing / Paddleboarding': 'Surfing / Paddleboarding',
    'Fishing': 'Fishing',
    'Gardening': 'Gardening',
    'Music (Playing an instrument / Listening)': 'Music (Playing an instrument / Listening)',
    'Podcasts': 'Podcasts',
    'Movies / TV Shows': 'Movies / TV Shows',
    'Drawing / Painting': 'Drawing / Painting',
    'Writing': 'Writing',
    'Learning Languages': 'Learning Languages',
    'Volunteering': 'Volunteering',
    'Meditation': 'Meditation',
    'Camping': 'Camping',
    'Motorcycling': 'Motorcycling',
    'Cars / Motorsports': 'Cars / Motorsports',
    'Collecting (e.g., cards, coins, stamps)': 'Collecting (e.g., cards, coins, stamps)',
    'DIY / Home Improvement': 'DIY / Home Improvement',
    'Chess / Strategy Games': 'Chess / Strategy Games',
    'Martial Arts (other than Jiu-Jitsu)': 'Martial Arts (other than Jiu-Jitsu)',
    'Team Sports (e.g., Soccer, Basketball, Volleyball)': 'Team Sports (e.g., Soccer, Basketball, Volleyball)',
    'Golf': 'Golf',
    'Tennis': 'Tennis',
    'Skiing / Snowboarding': 'Skiing / Snowboarding',
    'Table Tennis / Ping Pong': 'Table Tennis / Ping Pong',
    'Bowling': 'Bowling',
    'Dancing': 'Dancing',
    'Fashion / Style': 'Fashion / Style',
    'Astrology / Spirituality': 'Astrology / Spirituality',
    'Podcasting / Content Creation': 'Podcasting / Content Creation',
    'Woodworking': 'Woodworking',
    'Knitting / Crocheting': 'Knitting / Crocheting',
    'Calligraphy': 'Calligraphy',
    'Coding / Programming (as a hobby)': 'Coding / Programming (as a hobby)',
    'Brewing (Beer / Coffee)': 'Brewing (Beer / Coffee)',
    'Astronomy': 'Astronomy',
    'Birdwatching': 'Birdwatching',
    'Archery': 'Archery',
    'Hunting': 'Hunting',
    'Puzzles': 'Puzzles',
    'Other': 'Other'
  },
  pt: {
    'Reading': 'Leitura',
    'Hiking / Trekking': 'Caminhada / Trekking',
    'Photography': 'Fotografia',
    'Gaming (Video Games / Board Games)': 'Jogos (Videogames / Jogos de Tabuleiro)',
    'Cooking / Baking': 'Culinária / Confeitaria',
    'Traveling': 'Viagens',
    'Cycling (Road / Mountain)': 'Ciclismo (Estrada / Montanha)',
    'Running': 'Corrida',
    'Weightlifting / Fitness': 'Musculação / Fitness',
    'Yoga / Pilates': 'Yoga / Pilates',
    'Swimming': 'Natação',
    'Surfing / Paddleboarding': 'Surfe / Stand Up Paddle',
    'Fishing': 'Pesca',
    'Gardening': 'Jardinagem',
    'Music (Playing an instrument / Listening)': 'Música (Tocar instrumento / Ouvir)',
    'Podcasts': 'Podcasts',
    'Movies / TV Shows': 'Filmes / Séries de TV',
    'Drawing / Painting': 'Desenho / Pintura',
    'Writing': 'Escrita',
    'Learning Languages': 'Aprender Idiomas',
    'Volunteering': 'Voluntariado',
    'Meditation': 'Meditação',
    'Camping': 'Acampamento',
    'Motorcycling': 'Motociclismo',
    'Cars / Motorsports': 'Carros / Esportes Motorizados',
    'Collecting (e.g., cards, coins, stamps)': 'Colecionismo (ex: cartas, moedas, selos)',
    'DIY / Home Improvement': 'Faça Você Mesmo / Melhorias na Casa',
    'Chess / Strategy Games': 'Xadrez / Jogos de Estratégia',
    'Martial Arts (other than Jiu-Jitsu)': 'Artes Marciais (além do Jiu-Jitsu)',
    'Team Sports (e.g., Soccer, Basketball, Volleyball)': 'Esportes em Equipe (ex: Futebol, Basquete, Vôlei)',
    'Golf': 'Golf',
    'Tennis': 'Tênis',
    'Skiing / Snowboarding': 'Esqui / Snowboard',
    'Table Tennis / Ping Pong': 'Tênis de Mesa / Ping Pong',
    'Bowling': 'Boliche',
    'Dancing': 'Dança',
    'Fashion / Style': 'Moda / Estilo',
    'Astrology / Spirituality': 'Astrologia / Espiritualidade',
    'Podcasting / Content Creation': 'Podcasting / Criação de Conteúdo',
    'Woodworking': 'Marcenaria',
    'Knitting / Crocheting': 'Tricô / Crochê',
    'Calligraphy': 'Caligrafia',
    'Coding / Programming (as a hobby)': 'Programação (como hobby)',
    'Brewing (Beer / Coffee)': 'Cervejaria / Café',
    'Astronomy': 'Astronomia',
    'Birdwatching': 'Observação de Aves',
    'Archery': 'Tiro com Arco',
    'Hunting': 'Caça',
    'Puzzles': 'Quebra-Cabeças',
    'Other': 'Outro'
  }
};

// Mock de interesses
const interestsList = [
  'Reading', 'Hiking / Trekking', 'Photography', 'Gaming (Video Games / Board Games)',
  'Cooking / Baking', 'Traveling', 'Cycling (Road / Mountain)', 'Running',
  'Weightlifting / Fitness', 'Yoga / Pilates', 'Swimming', 'Surfing / Paddleboarding',
  'Fishing', 'Gardening', 'Music (Playing an instrument / Listening)', 'Podcasts',
  'Movies / TV Shows', 'Drawing / Painting', 'Writing', 'Learning Languages',
  'Volunteering', 'Meditation', 'Camping', 'Motorcycling', 'Cars / Motorsports',
  'Collecting (e.g., cards, coins, stamps)', 'DIY / Home Improvement', 'Chess / Strategy Games',
  'Martial Arts (other than Jiu-Jitsu)', 'Team Sports (e.g., Soccer, Basketball, Volleyball)',
  'Golf', 'Tennis', 'Skiing / Snowboarding', 'Table Tennis / Ping Pong', 'Bowling',
  'Dancing', 'Fashion / Style', 'Astrology / Spirituality', 'Podcasting / Content Creation',
  'Woodworking', 'Knitting / Crocheting', 'Calligraphy', 'Coding / Programming (as a hobby)',
  'Brewing (Beer / Coffee)', 'Astronomy', 'Birdwatching', 'Archery', 'Hunting', 'Puzzles', 'Other',
];

type InterestsStepProps = {
  selected: string[];
  setSelected: React.Dispatch<React.SetStateAction<string[]>>;
};

export function InterestsStep({ selected, setSelected }: InterestsStepProps) {
  const { t, currentLanguage } = useI18n();
  const [search, setSearch] = useState('');
  const [allInterests, setAllInterests] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  // Função para traduzir interesses
  const translateInterest = (interest: string): string => {
    const lang = currentLanguage === 'pt' ? 'pt' : 'en';
    return interestsTranslations[lang]?.[interest] || interest;
  };

  useEffect(() => {
    const fetchInterests = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('hobbies')
        .select('name')
        .order('name', { ascending: true });
      if (!error && data) {
        setAllInterests(data.map((item: any) => item.name));
      }
      setLoading(false);
    };
    fetchInterests();
  }, []);

  const filtered = allInterests.filter(
    (i) => i.toLowerCase().includes(search.toLowerCase()) && !selected.includes(i)
  );

  const handleAdd = (interest: string) => {
    if (!selected.includes(interest) && selected.length < 5) {
      setSelected([...selected, interest]);
      setSearch('');
    }
  };

  const handleRemove = (interest: string) => {
    setSelected(selected.filter((i) => i !== interest));
  };

  const maxInterests = 5;
  const reachedMax = selected.length >= maxInterests;

  return (
    <div>
      <h2 className="text-lg font-semibold mb-2 font-sans">{t('onboarding.interests.title')}</h2>
      <p className="mb-4 text-black font-sans">{t('onboarding.interests.subtitle')}</p>
      <Input
        placeholder={loading ? t('onboarding.interests.loading') : t('onboarding.interests.search_placeholder')}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="mb-2 bg-white text-black placeholder:text-[#b0b0b0] border-black font-sans"
        disabled={reachedMax || loading}
        labelColor="#b0b0b0"
        onKeyDown={(e) => {
          if (e.key === 'Enter' && search.trim() && !reachedMax) {
            handleAdd(search.trim());
          }
        }}
      />
      {search && filtered.length > 0 && !reachedMax && !loading && (
        <div className="border rounded bg-white p-2 mb-2 max-h-32 overflow-y-auto">
          {filtered.map((interest) => (
            <div
              key={interest}
              className="cursor-pointer px-2 py-1 hover:bg-sossiety-red hover:text-white rounded font-sans text-black"
              onClick={() => handleAdd(interest)}
            >
              {translateInterest(interest)}
            </div>
          ))}
        </div>
      )}
      {search && filtered.length === 0 && !reachedMax && !loading && (
        <div className="border rounded bg-white p-2 mb-2">
          <div
            className="cursor-pointer px-2 py-1 hover:bg-sossiety-red hover:text-white rounded font-sans text-black"
            onClick={() => handleAdd(search.trim())}
          >
            {t('onboarding.interests.add_interest', { interest: search.trim() })}
          </div>
        </div>
      )}
      <div className="mb-4">
        <div className="font-medium mb-1 text-black font-sans">{t('onboarding.interests.interests_label')}</div>
        <div className="flex flex-wrap gap-2 mb-2">
          {selected.map((interest) => (
            <span
              key={interest}
              className="inline-flex items-center rounded-full bg-red-100 text-red-700 border border-red-200 px-4 py-1 text-xs font-medium font-sans mr-2 mb-2"
            >
              {translateInterest(interest)}
              <button
                type="button"
                onClick={() => handleRemove(interest)}
                className="ml-2 text-xs text-red-400 hover:text-red-700 focus:outline-none"
                aria-label={`Remove ${translateInterest(interest)}`}
              >
                ×
              </button>
            </span>
          ))}
        </div>
        <div className="text-xs text-[#b0b0b0] mt-1 font-sans">
          {t('onboarding.interests.interests_count', { count: selected.length, max: maxInterests })}
        </div>
        {reachedMax && (
          <div className="text-xs text-red-500 mt-1 font-sans">{t('onboarding.interests.max_interests_reached')}</div>
        )}
      </div>
    </div>
  );
} 